import { motion } from "motion/react";
import cx from "classnames";

const variants = {
  hide: { opacity: 0, scale: 0 },
  show: { opacity: 1, scale: 1 },
};

export default function UpdatePoint({
  show,
  size,
  className,
}: {
  show: boolean;
  size: "small" | "medium";
  className?: string;
}) {
  return (
    <motion.div
      className={cx(
        "rounded-full bg-ocean-400",
        {
          "w-3 h-3": size === "medium",
          "w-2 h-2": size === "small",
        },
        className
      )}
      variants={variants}
      initial={show ? "show" : "hide"}
      animate={show ? "show" : "hide"}
    />
  );
}
